import apiClient from './api/apiClient';

export interface ClassBanner {
  id: number;
  title: string;
  description: string;
  image_url: string;
  font_color_hex_code: string;
}

export interface ClassBannerResponse {
  code: number;
  status: string;
  message: string;
  data: ClassBanner[];
}

export const classBannerApi = {
  // 클래스 배너 목록 조회
  getClassBanners: async (): Promise<ClassBanner[]> => {
    try {
      const response = await apiClient.get<ClassBannerResponse>('/api/ui/class/banners/list');
      return response.data.data;
    } catch (error: any) {
      /// console.error('클래스 배너 데이터 로딩 실패:', error);
      throw error;
    }
  }
};
